import { AlignHorizontalLeft, Analytics, Compress, FilePresent, Folder, GroupAdd, List, MenuBook, PeopleAltOutlined, PrecisionManufacturingOutlined, Task, ViewQuilt } from "@mui/icons-material";
import { SelectBoxOption } from "../../interfaces";
import { AppRoutes } from "../../router/routes";

export const BOMTypeOptions: SelectBoxOption[] = [{ value: "individual", label: "Individual Part ID" }, { value: "assembled", label: "Assembly ID" }, { value: "block", label: "Area ID" }];

export const NavBars = (
    id: string,
    isEdit: boolean = false,
    loading: boolean = false,
    tags: { tag_id: string, tag_name: string }[] = [],
    tag_group_id: string,
    technicalParameterPath: string,
) => ([
    {
        id: "1",
        title: "Basic Details",
        icon: <AlignHorizontalLeft fontSize="small" />,
        path: AppRoutes.viewProductBasicDetail(id)
    },
    {
        id: "15",
        title: "Collaborate",
        disabled: !isEdit,
        icon: <PeopleAltOutlined fontSize="small" />,
        path: AppRoutes.collaborate('product', id)
    },
    {
        id: "2",
        title: "Data Table",
        disabled: !isEdit,
        icon: <Analytics fontSize="small" />,
        path: AppRoutes.viewProductTechParamForm(id, technicalParameterPath)
    },
    {
        id: "12",
        title: "Task Manager",
        isBeta: true,
        disabled: !isEdit,
        icon: <Task fontSize="small" />,
        path: AppRoutes.tasks('product', id)
    },
    {
        id: "3",
        title: "Documents",
        disabled: !isEdit,
        icon: <Folder fontSize="small" />,
        path: AppRoutes.viewProductDocuments(id),
    },
    // {
    //     id: "4",
    //     title: "IEDRAW",
    //     disabled: !isEdit,
    //     isActive: false,
    //     isBeta: true,
    //     icon: <Architecture fontSize="small" />,
    //     path: AppRoutes.viewProductIEDraw(id),
    // },
    // {
    //     id: "5",
    //     title: "IEDOCS",
    //     disabled: !isEdit,
    //     isBeta: true,
    //     icon: <Article fontSize="small" />,
    //     path: AppRoutes.viewProductIEDocs(id),
    // },
    {
        id: "6",
        title: "Material",
        disabled: !isEdit,
        icon: <FilePresent fontSize="small" />,
        path: AppRoutes.viewProductMaterial(id) + "?tab=material",
    },
    {
        id: "7",
        title: "BOMs",
        disabled: !isEdit,
        icon: <ViewQuilt fontSize='small' />,
        path: AppRoutes.viewProductBOM(id),
    },
    {
        id: "8",
        title: "BOM Report",
        disabled: !isEdit,
        icon: <List fontSize='small' />,
        path: AppRoutes.viewBOMReportOnProductModule(id),
    },
    {
        id: "9",
        title: "List View",
        disabled: !isEdit,
        icon: <Compress fontSize='small' />,
        path: AppRoutes.viewListViewOnProductModule(id),
    },
    {
        id: "10",
        title: "Workbook",
        disabled: !isEdit,
        icon: <MenuBook fontSize='small' />,
        path: AppRoutes.workbookOnProductModule(id),
    },
    // {
    //     id: "11",
    //     title: "Issue Tracker",
    //     disabled: !isEdit,
    //     icon: <Troubleshoot fontSize="small" />,
    //     path: AppRoutes.viewIssueTrackerOnProduct(id)
    // },
    {
        id: "13",
        title: "AI Search",
        disabled: !isEdit,
        icon: <PrecisionManufacturingOutlined fontSize="small" />,
        path: AppRoutes.viewProductAISearch(id)
    },
    {
        id: "14",
        title: "Manage Users",
        disabled: !isEdit,
        icon: <GroupAdd fontSize="small" />,
        path: AppRoutes.manageUsersOnProduct(id)
    },
])

export const MDGTypeOptions = [{ value: "Generate using MDG", label: "Generate using MDG" }, { value: "Manually Enter the Description", label: "Manually Enter the Description" }];